<template>
  <a :href="searchResultLink" class="result-card flex-row align-items-center gap-sm">
    <avatar-component v-bind:customer-id="result.id"></avatar-component>

    <div class="grid flex-stretch mr-xxs">
      <p class="font-size-md mb-xxs color-primary font-regular text-capitalize">
        {{ fullName }}
      </p>

      <table class="flex-row align-items-center">
        <span v-if="result.type === customerTypeEnum.LEAD" class="label label-danger mr-xxs">LEAD</span>
        <span v-if="result.type === customerTypeEnum.MORTGAGE_LEAD" class="label label-danger mr-xxs">Hypotheek LEAD</span>
        <span v-if="result.type === customerTypeEnum.INSURANCE_LEAD" class="label label-danger mr-xxs">Verzekering LEAD</span>

        <p class="font-size-sm mb-0" v-if="result.birthday">
          {{ result.birthday }} (&hairsp;{{result.age}}&hairsp;)
        </p>
      </table>
    </div>

    <div v-if="address" class="grid">
      <p class="font-size-sm mb-0" style="text-align: right">
        {{ streetAddress }}
      </p>
      <p class="font-size-sm mb-0" style="text-align: right">
        {{ postalCode_City }}
      </p>
    </div>
  </a>
</template>

<script>
import customerTypeEnum from "~/enums/CustomerTypeEnum.js";
import AvatarComponent from "~/modules/customer/components/AvatarComponent.vue";
export default {
  name: "Customer.vue",
  components: {
    AvatarComponent,
  },
  data(){
    return {
      customerTypeEnum: customerTypeEnum
    }
  },
  props: {
    result: {
      first_name: {
        type: String,
        required: true,
      },
      last_name: {
        type: String,
        required: true,
      },
      suffix: {
        type: String,
        required: false,
      },
      initials: {
        type: String,
        required: false,
      },
      birthday: {
        type: String,
        required: false,
      },
    },
  },
  computed: {
    searchResultLink() {
      return '/customer/' + this.result.id +  '/dashboard';
    },
    fullName: function () {
      return (this.result.first_name ? this.result.first_name + ' ' : '') + (this.result.suffix ? this.result.suffix + ' ' : '') + (this.result.last_name ? this.result.last_name + ' ' : '');
    },
    address() {
      return this.result.current_visit_customer_property?.data.property?.data;
    },
    streetAddress(){
      if (!this.address) return;
      return (this.address.street ? this.address.street + ' ' : '') + (this.address.number ? this.address.number : '') + (this.address.number_addition ? this.address.number_addition : '');
    },
    postalCode_City(){
      if (!this.address) return;
      return (this.address.postal_code ? this.address.postal_code + ' ' : '') + (this.address.city ? this.address.city : '');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

</style>
